import React from 'react';
import { getUser, logout } from '../../utils/auth';
import './AdminHeader.css';

const AdminHeader = ({ onToggleSidebar }) => {
  const user = getUser();

  return (
    <header className="admin-header">
      <button className="admin-header-menu" onClick={onToggleSidebar}>
        ☰
      </button>
      <div className="admin-header-spacer" />
      <div className="admin-header-user">
        <span className="admin-header-name">{user?.name || 'Admin'}</span>
        <span className="admin-header-role">
          {user?.role === 'SUPER_MASTER' ? 'Super Master' : 'Master'}
        </span>
      </div>
      <button className="admin-header-logout" onClick={logout}>
        Logout
      </button>
    </header>
  );
};

export default AdminHeader;
